import { Component, Input, OnChanges } from '@angular/core';

import { MatchExclusion } from '@libs/src/models/account.model';

import includes from 'lodash-es/includes';

@Component({
  selector: 'app-match-exclusions-display',
  templateUrl: './match-exclusions-display.component.html',
})
export class MatchExclusionsDisplayComponent implements OnChanges {
  @Input() matchExclusions: MatchExclusion[];
  filteredMatchExclusions: {
    accountExclusions: MatchExclusion[];
    segmentExclusions: MatchExclusion[];
  } = { accountExclusions: [], segmentExclusions: [] };

  ngOnChanges(): void {
    this.filteredMatchExclusions = this.filterMatchExclusions(
      this.matchExclusions,
    );
  }

  filterMatchExclusions(exclusions: MatchExclusion[] = []) {
    return {
      accountExclusions: exclusions.filter(({ exclusion_type }) =>
        includes(['_id', 'email'], exclusion_type),
      ),
      segmentExclusions: exclusions.filter(({ exclusion_type }) =>
        includes(['custom_segment', 'match_segment'], exclusion_type),
      ),
    };
  }
}
